import { $, $$ } from 'utils/dom';
import Shower from 'modules/shower';

const imageDescriptions = $$('.image-description');

if (imageDescriptions.length) {
  imageDescriptions.forEach(description => {
    const target = $('.image-description__content', description);
    const handler = $('.image-description__open-close', description);

    new Shower({
      target,
      handler,
      easing: 'ease',
      duration: 200,
      initOpened: false,
      openClassName: 'image-description--active',
    }).init();
  });
}
